// extracted by mini-css-extract-plugin
export default {"xs":"30rem","sm":"48rem","md":"64rem","lg":"75rem","xl":"90rem"};